var account = "Account";
var accountSettings = "Accountinstellingen";
var charging = "Opladen";
var contactInfo = "Contactgegevens";
var dashboard = "Dashboard";
var home = "Home";
var myProducts = "Mijn producten";
var orderHistory = "Bestelgeschiedenis";
var paymentMethod = "Betalingsmethode";
var profileSettings = "Instellingen profiel";
var referAndEarn = "Refereren en verdienen";
var signOut = "Afmelden";
var nl_NL = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, nl_NL as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
